// extracted by mini-css-extract-plugin
export default {"page":"info_page__34kT4","thnx1":"info_thnx1__QHeL2","thnx2":"info_thnx2__d1g2F","about":"info_about__5UCQU","SFIimg":"info_SFIimg__Qm24z","hagarimg":"info_hagarimg__OBYkU"};